<template>
  <div class="hidden md:flex items-center justify-between mb-1">
    <div class="text-3xl font-bold">
      <span> Ticket </span>
    </div>
    <div
      v-if="hasTicket"
      class="flex flex-cols items-center text-gray-500 text-3xl font-bold"
    >
      <i-ticket-o classes="w-10 ml-2 mr-1 "></i-ticket-o>
      <span class="text-2xl"> #{{ loadedTicket.id }} </span>
    </div>
    <div class="flex-grow flex justify-end items-center">
      <base-refresh-string
        :isUpdating="!hasTicket || isUpdating"
        timePointer="tickets/updateDatetime"
        @refresh="loadTicket()"
      ></base-refresh-string>
    </div>
  </div>
  <div class="md:hidden text-gray-800 mt-4 sm:-mt-1 -mb-4 mx-auto text-md ">
    <div class="">
      Supporto
    </div>
  </div>
</template>

<script>
export default {
  name: "TheTicketTitle",
  data() {
    return {
      isUpdating: false,
    };
  },
  computed: {
    loadedTicket() {
      return this.$store.getters["tickets/loadedTicket"];
    },
    hasTicket() {
      return this.loadedTicket != null;
    },
  },
  methods: {
    async loadTicket() {
      this.isUpdating = true;
      try {
        await this.$store.dispatch("tickets/getTicket", {
          id: this.loadedTicket.id,
        });
      } catch (error) {
        this.error = error.message || "Something went wrong!";
      }
      this.isUpdating = false;
    },
  },
};
</script>
